import { useTranslation } from "../../core/translation.core";
import useShop, { useShopFull } from "../../hooks/useShop.hook";
import { Reward } from "../../types/reward";
import { Tag } from "../reuseables/list.comp";
import { format, addMonths } from "date-fns";

export default function RewardListRow({ reward }: { reward: Reward }) {
  const { selectedShop } = useShop();
  const { data: shop } = useShopFull();
  const { t, msg } = useTranslation();

  if (!selectedShop) return null;

  const shopRewardExpireDays = shop?.rewardExpireAfter;
  const months = Math.floor((shopRewardExpireDays ? shopRewardExpireDays : 400) / 30);

  const rewardExpireDate = reward.expirationDate
    ? format(new Date(reward.expirationDate), "yyyy-MM-dd HH:mm:ss")
    : reward.rewardDate
    ? format(addMonths(new Date(reward.rewardDate), months), "yyyy-MM-dd HH:mm:ss")
    : "N/A";
  const status = reward.points < 0 ? t(msg.reward.redeemed) : getStatus();

  return (
    <div className="my-grid-row gap-x-4 py-6">
      <div data-value={reward?.orderNumber}>
        <Tag>{t(msg.order.orderNumber)}</Tag>
        <p>{reward?.orderNumber}</p>
      </div>

      <div data-value={reward.user?.firstName}>
        <Tag>{t(msg.general.name)}</Tag>
        <p>
          {reward.user?.firstName.toUpperCase() ?? "N/A"} {reward.user?.lastName.toUpperCase() ?? "N/a"}
        </p>
      </div>
      <div data-value={reward.rewardDate}>
        <Tag>{t(msg.reward.purchaseDate)}</Tag>
        <p>{reward.rewardDate ? format(new Date(reward.rewardDate), "yyyy-MM-dd HH:mm:ss") : "N/A"}</p>
      </div>
      <div data-value={rewardExpireDate}>
        <Tag>{t(msg.reward.expiresOn)}</Tag>
        <p>{rewardExpireDate}</p>
      </div>
      <div data-value={status}>
        <Tag>{t(msg.reward.rewardStatus)}</Tag>
        <p>{status}</p>
      </div>
      <div data-value={reward.points}>
        <Tag>{t(msg.reward.points)}</Tag>
        <p>{reward.points}</p>
      </div>
    </div>
  );

  function getStatus() {
    switch (reward.status) {
      case "active":
        return t(msg.reward.active);
      case "expired":
        return t(msg.reward.expired);
      case "pending":
        return t(msg.order.pending);
      case "cancelled":
        return t(msg.order.cancelled);
      // case "redeemed":
      //   return t(msg.reward.redeemed);
    }
  }
}
